export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"We are re-imagining and reworking how betting works, playing raffle draws and other exciting games. Harness the power of freedom, choose your specialty, make the rules, and play on your own terms."},{"name":"keywords","content":"Luckee, Play on online, Stake and Earn, Online Earning, Digital Gaming, luck, lucky, luckee, win, odds, raffle, raffle draws, bet, gaming, betting, gambling, gamble, lottery, lotto, winner"},{"name":"theme-color","content":"#27AB83"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Luckee - Every hand is a winner"},{"name":"twitter:description","content":"We are re-imagining and reworking how betting works, playing raffle draws and other exciting games. Harness the power of freedom, choose your specialty, make the rules, and play on your own terms."},{"name":"twitter:site","content":"@LuckeeNg"},{"name":"twitter:app:country","content":"NG"},{"name":"twitter:image:src","content":"https://luckee.vercel.app/assets/og-images/og-luckee.png"},{"name":"twitter:url","content":"https://app.luckee.ng"},{"name":"og:title","content":"Luckee - Every hand is a winner"},{"name":"og:description","content":"We are re-imagining and reworking how betting works, playing raffle draws and other exciting games. Harness the power of freedom, choose your specialty, make the rules, and play on your own terms."},{"name":"og:url","content":"https://app.luckee.ng"},{"name":"og:site_name","content":"Luckee"},{"name":"og:type","content":"website"},{"name":"og:image","content":"https://luckee.vercel.app/assets/og-images/og-luckee.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"canonical","href":"https://app.luckee.ng"}],"style":[],"script":[],"noscript":[],"charset":"utf-8","htmlAttrs":{"lang":"en"},"viewport":"width=device-width, initial-scale=1","title":"Luckee - Every hand is a winner"}

export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false